import axios from 'axios';
import { pb } from './pocketbase';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

// Export des formations avec ruptures et nombre d'élèves - Téléchargement direct en Excel
export const exportFormationsRuptures = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/export/formations-ruptures`, {
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            },
            responseType: 'blob' // Important pour télécharger en tant que blob
        });
        
        // Extraire le nom de fichier depuis les en-têtes de réponse
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'export-formations-ruptures.xlsx';
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch) {
                filename = filenameMatch[1];
            }
        }
        
        // Créer et télécharger le fichier Excel
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Nettoyer l'URL créée
        URL.revokeObjectURL(url);
        
        return { success: true, filename };
    } catch (error) {
        console.error("Error exporting formations ruptures data:", error);
        throw error;
    }
};

// Export des top formations avec qualification_title, nombre de promotions et nombre d'élèves - Téléchargement direct en Excel
export const exportTopFormations = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/export/top-formations`, {
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            },
            responseType: 'blob' // Important pour télécharger en tant que blob
        });
        
        // Extraire le nom de fichier depuis les en-têtes de réponse
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'export-top-formations.xlsx';
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch) {
                filename = filenameMatch[1];
            }
        }
        
        // Créer et télécharger le fichier Excel
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Nettoyer l'URL créée
        URL.revokeObjectURL(url);
        
        return { success: true, filename };
    } catch (error) {
        console.error("Error exporting top formations data:", error);
        throw error;
    }
};


// Moteur d'export dynamique

// Récupérer toutes les collections PocketBase disponibles
export const getCollections = async () => {
    try {
        if (!pb.authStore.isValid) {
            throw new Error('Utilisateur non connecté');
        }

        // Liste des collections connues dans votre système
        // Tu peux ajuster cette liste selon tes besoins
        const knownCollections = [
            'students', 'formations', 'contracts', 'companies', 
            'prospects_student', 'centers', 'promotions','tutors'
        ];
        
        // Tester chaque collection pour voir si elle existe et est accessible
        const availableCollections = [];
        
        for (const collectionName of knownCollections) {
            try {
                // Tester l'accès à la collection en récupérant juste 1 élément
                await pb.collection(collectionName).getList(1, 1);
                availableCollections.push({
                    name: collectionName,
                    id: collectionName,
                    type: 'base'
                });
                console.log(`Collection accessible: ${collectionName}`);
            } catch (error) {
                console.warn(`Collection non accessible: ${collectionName}`, error.message);
            }
        }
        
        console.log('Collections disponibles:', availableCollections);
        return availableCollections;
    } catch (error) {
        console.error("Erreur lors de la récupération des collections:", error);
        throw error;
    }
};

// Récupérer les champs d'une collection en analysant un échantillon de données
export const getCollectionFields = async (collectionName) => {
    try {
        if (!pb.authStore.isValid) {
            throw new Error('Utilisateur non connecté');
        }

        // Récupérer quelques éléments de la collection pour analyser la structure
        const response = await pb.collection(collectionName).getList(1, 5);
        
        if (response.items.length === 0) {
            console.warn(`Collection ${collectionName} est vide`);
            return [];
        }
        
        // Analyser la structure du premier élément
        const sampleItem = response.items[0];
        const fields = [];
        
        Object.keys(sampleItem).forEach(key => {
            // Exclure les champs système et techniques
            if (!key.startsWith('_') && 
                !['id', 'created', 'updated', 'collectionId', 'collectionName'].includes(key)) {
                
                const value = sampleItem[key];
                let type = 'text';
                
                // Deviner le type basé sur la valeur
                if (typeof value === 'number') {
                    type = 'number';
                } else if (typeof value === 'boolean') {
                    type = 'bool';
                } else if (value && typeof value === 'string') {
                    // Vérifier si c'est une date
                    if (value.match(/^\d{4}-\d{2}-\d{2}/) && !isNaN(Date.parse(value))) {
                        type = 'date';
                    } else if (value.includes('@')) {
                        type = 'email';
                    }
                }
                
                fields.push({
                    name: key,
                    type: type,
                    required: false,
                    options: {}
                });
            }
        });
        
        console.log(`Champs détectés pour ${collectionName}:`, fields);
        return fields;
    } catch (error) {
        console.error(`Erreur lors de la récupération des champs pour ${collectionName}:`, error);
        throw error;
    }
};

// Exporter plusieurs collections avec leurs champs sélectionnés (1 sheet par collection)
export const exportMultiCollectionData = async (collectionsData, format = 'excel') => {
    try {
        const response = await axios.post(`${API_BASE_URL}/api/export/multi-collection`, {
            collections: collectionsData, // [{collection: 'students', fields: ['name', 'email']}, ...]
            format: format
        }, {
            headers: {
                'Accept': format === 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/json',
                'Authorization': `Bearer ${pb.authStore.token}`,
                'Content-Type': 'application/json'
            },
            responseType: 'blob'
        });
        
        // Extraire le nom de fichier depuis les en-têtes de réponse
        const contentDisposition = response.headers['content-disposition'];
        let filename = `export-multi-collections.${format === 'excel' ? 'xlsx' : 'json'}`;
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/); 
            if (filenameMatch) {
                filename = filenameMatch[1];
            }
        }
        
        // Créer et télécharger le fichier
        const mimeType = format === 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/json';
        const blob = new Blob([response.data], { type: mimeType });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Nettoyer l'URL créée
        URL.revokeObjectURL(url);
        
        return { success: true, filename };
    } catch (error) {
        console.error(`Error exporting multi-collections:`, error);
        throw error;
    }
};

// Exporter les données d'une collection avec les champs sélectionnés
export const exportCollectionData = async (collectionName, selectedFields, format = 'excel') => {
    try {
        const response = await axios.post(`${API_BASE_URL}/api/export/collection`, {
            collection: collectionName,
            fields: selectedFields,
            format: format
        }, {
            headers: {
                'Accept': format === 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/json',
                'Authorization': `Bearer ${pb.authStore.token}`,
                'Content-Type': 'application/json'
            },
            responseType: 'blob'
        });
        
        // Extraire le nom de fichier depuis les en-têtes de réponse
        const contentDisposition = response.headers['content-disposition'];
        let filename = `export-${collectionName}.${format === 'excel' ? 'xlsx' : 'json'}`;
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/); 
            if (filenameMatch) {
                filename = filenameMatch[1];
            }
        }
        
        // Créer et télécharger le fichier
        const mimeType = format === 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/json';
        const blob = new Blob([response.data], { type: mimeType });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Nettoyer l'URL créée
        URL.revokeObjectURL(url);
        
        return { success: true, filename };
    } catch (error) {
        console.error(`Error exporting collection ${collectionName}:`, error);
        throw error;
    }
};